import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const calendarEventsQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "calendarEvents">,
    GQL.IQueryCalendarEventsArgs
> = gql`
    query calendarEvents($companyId: ID!, $from: String!, $to: String!) {
        calendarEvents(companyId: $companyId, from: $from, to: $to) {
            id
            companyId
            createdBy
            assigneeId
            title
            notes
            type
            eventDate
            contactId
            color
            createdAt
            updatedAt
        }
    }
`;

// SP3 (FIBU-22): one unified query covering both refTypes, no date range (the
// table has no date column - design spec §III.6/§III.11 decision #1).
export const calendarItemStatesQuery: TypedDocumentNode<
    Pick<GQL.IQuery, "calendarItemStates">,
    GQL.IQueryCalendarItemStatesArgs
> = gql`
    query calendarItemStates($companyId: ID!) {
        calendarItemStates(companyId: $companyId) {
            companyId
            refType
            refId
            doneAt
            acknowledgedAt
            note
            color
            updatedAt
        }
    }
`;
